import { useLocation, useNavigate } from "react-router-dom";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import RoundedDropdown from "../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useEffect, useState } from "react";
import { useEmployeeListByUnit, useExpenseList } from "./hooks/useExpense";
import {
  useGetDesignationsData,
  useGetEmployeeStatusData,
} from "../Employee/hooks/useEmployee";
import { FaEye } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
  setPage,
  setLimit,
  setDesignation,
  setEmployeeStatus,
  setExpenseStatus,
  resetDropDown,
  resetPagination,
} from "../../ReduxToolkit/Reducers/Expense/EmployeeList_Slice";
import { useHardRefresh } from "../../Component/BasicComponents/Hooks/useHardRefresh";
import { COLORS } from "../../constants/colors";
import { showToast } from "../../utils/toastUtils";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";
import { useExcelPolling } from "../../hooks/useExcelPolling";

const EmployeeList = () => {
  const { filter, dropDown } = useSelector((state: any) => state.employee);
  const { startPolling } = useExcelPolling();
  const { filter: expenseSlice_filter } = useSelector(
    (state: any) => state.expense
  );
  const {
    filter: AduditSlice_filter,
    auditScreenStatus: auditScreenStatus_redux,
  } = useSelector((state: any) => state.audit);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const [refresh, setRefresh] = useState(false);
  const [excelLoaing, setExcelLoading] = useState<boolean>(false);
  const [excelStatus, setExcelStatus] = useState<string | null>("Loading.");

  const data = useLocation();

  useEffect(() => {
    setRefresh(!refresh);
  }, [dropDown]);

  const employeeStatus = useGetEmployeeStatusData({ enable: true });
  const {
    data: expensStausData,
    isLoading: expensIsLoading,
    isSuccess: expensStausISsuccess,
  } = useExpenseList({ enable: true });

  const employeeColumns = (handleEmpView: (row: any) => void): any[] => [
    {
      name: "Emp Name",
      selector: (row: {
        FirstName: number | string;
        LastName: Number | string;
      }) => `${row.FirstName}` + " " + `${row.LastName}`,
      sortable: true,
      wrap: true,
      width: "150px",

      headCells: {
        style: {
          "&:first-of-type": {
            position: "sticky",
            left: 0,
            backgroundColor: "#fff",
            zIndex: 3,
          },
        },
      },
      style: {
        position: "sticky",
        left: 0,
        backgroundColor: "#fff",
        zIndex: 3,
        borderRight: "1px solid #ddd",
      },
    },
    {
      name: "Emp code",
      selector: (row: { EmployeeCode: number | string }) => row.EmployeeCode,
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      name: "Designation",
      selector: (row: { Designation: string }) => row.Designation || "-",
      wrap: true,
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Reporting To",
      selector: (row: { ReportingTo: string }) => row.ReportingTo || "-",
      minWidth: "150px",
      sortable: true,
    },
    {
      name: " HQ (City )",
      selector: (row: { HQ: string }) => row.HQ || "-",
      sortable: true,
      minWidth: "150px",
    },

    {
      name: "Created On",
      selector: (row: { submitted: string }) => row.submitted || "-",
      minWidth: "140px",
      wrap: true,
      sortable: true,
    },
    {
      name: "Requested",
      selector: (row: { ExpenseReqAmt: string }) => row.ExpenseReqAmt || "-",
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Approved",
      selector: (row: { ExpenseApprovedAmt: string }) =>
        row.ExpenseApprovedAmt || "-",
      sortable: true,
      minWidth: "150px",
    },

    {
      name: "Audited",
      selector: (row: { ExpenseFinalAmt: string }) =>
        row.ExpenseFinalAmt || "-",
      sortable: true,
      minWidth: "150px",
    },

    {
      name: "Working Day",
      selector: (row: { AttendanceTotal: string }) =>
        row.AttendanceTotal || "-",
      minWidth: "150px",
      sortable: true,
    },

    {
      name: "Total FW",
      selector: (row: { FW: string }) => row.FW || "-",
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Tatal NCA",
      selector: (row: { NCA: string | number }) =>
        row.NCA === 0 || row.NCA === "0" ? "0" : row.NCA?.toString() || "-",
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Emp Status",
      selector: (row: { Status: string | number }) =>
        row.Status == 1 ? "Active" : "Inactive",
      minWidth: "150px",
      sortable: true,
    },
    {
      name: "Exp Status",
      selector: (row: { ExpenseStatus: string | number }) => row.ExpenseStatus,
      minWidth: "150px",
      sortable: true,
      wrap: true,
    },
    {
      name: "Actions",
      cell: (row: any) => (
        <button
          onClick={() => handleEmpView(row)}
          className="btn btn-primary"
          style={{
            borderRadius: "20px",
            padding: "5px",
            width: "65px",
            height: "25px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "14px",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} />
          View
        </button>
      ),
    },
  ];

  const { auditScreenStatus } = location.state || {};
  const handleEmpView = (row: any) => {
    navigate("/expense/employeeList/employeeExpView", {
      state: {
        id: row?.EmployeeId,
        monthYear: expenseSlice_filter.month,
        auditScreenStatus,
      },
    });
  };

  useHardRefresh(() => {
    dispatch(resetDropDown(), resetPagination());
  });

  const {
    data: employeeListByUnit,
    isLoading,
    isSuccess,
  } = useEmployeeListByUnit({
    id: data?.state?.row?.OrgunitId,
    params: {
      ...(dropDown.designation.id !== "" && {
        designation:
          dropDown.designation.label == "All" ? "" : dropDown.designation.label,
      }),
      ...(dropDown.employeeStatus.id !== "" && {
        status: dropDown.employeeStatus.id,
      }),
      ...(dropDown.expenseStatus.id !== "null" && {
        expenseStatus: dropDown.expenseStatus.id,
      }),
      month:
        auditScreenStatus_redux === true
          ? AduditSlice_filter.filter.month.id
          : expenseSlice_filter.month.id,
      start: filter.page,
      length: filter.limit,
      IsExpense: auditScreenStatus === undefined ? 1 : 0,
    },
    enable: !!data?.state?.row?.OrgunitId,
  });

  const ExpenseStatusWith_All = [
    { id: "0", label: "All" },
    ...(expensStausData?.formatedData || []),
  ];
  const { data: designationsData } = useGetDesignationsData({ enable: true });

  //getting full status form APIs' But due to Expense and Audit screen managing the data form Expense Status dropDown
  const excludesIDs = auditScreenStatus
    ? ["1", "2", "4", "7", "8", "9", "11"]
    : ["4", "7", "8", "9", "11"];
  const formated_ExpenseStatusWith_All = ExpenseStatusWith_All.filter(
    (item: any) => !excludesIDs.includes(item.id)
  );

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    dispatch(setPage(pageNo));
    dispatch(setLimit(limit));
  };

  const handlePagination = (pageNo: number) => {
    dispatch(setPage(pageNo));
  };

  const handleDesignation = (val: any) => {
    dispatch(setDesignation(val));
  };
  const handleEmpolyee_status = (val: any) => {
    dispatch(setEmployeeStatus(val));
  };

  const handleExpense_status = (val: any) => {
    dispatch(setExpenseStatus(val));
  };


  const downoadExcel = async () => {
    const params: Record<string, any> = {
      ...(dropDown.designation.id !== "" && {
        designation:dropDown.designation.label == "All" ? "" : dropDown.designation.label,}),
      ...(dropDown.employeeStatus.id === null? {}: { status: dropDown.employeeStatus.id }),
      ...(dropDown.expenseStatus.id !== "null" && {
        expenseStatus: Number(dropDown.expenseStatus.id),
      }),
      ...{
        month:
          auditScreenStatus_redux === true
            ? AduditSlice_filter.filter.month.id
            : expenseSlice_filter.month.id,
      },
      ...{ IsExpense: auditScreenStatus === undefined ? 1   : 0 },
    };
    const queryString = new URLSearchParams(params).toString();

    try {
      setExcelLoading(true);
      const response = await axiosInstance.get(`${API_ENDPOINTS.EXPENSE.GET_EXCEL_DOWNLOAD_EMP_LIST}/${data?.state?.row?.OrgunitId}?${queryString}`);
      const { success, fileDownloadId, intervalTime } = response?.data?.data || null;
      if (success && fileDownloadId) {
        startPolling(fileDownloadId, intervalTime, {
          onStatusUpdate: (currentStatus: string) => {
            setExcelStatus(currentStatus);
          },
          onSuccess: (url: any) => {
            setExcelLoading(false);
            setExcelStatus("Loading..");
            const a = document.createElement("a");
            a.href = url;
            a.download = "report.xlsx";
            a.click();
            showToast.success("This file is ready!");
          },
          onFailed: (msg: any) => showToast.error(msg || ""),
          onExpired: (msg: any) => showToast.error(msg || ""),
          onDeleted: (msg: any) => showToast.error(msg || ""),
        });
      }
    } catch (error: any) {
      showToast.error(error);
      console.log("Something Went Wrong inDownLoad Excel", error);
    }
  };

  return (
    <div style={{ maxWidth: "100%" }} className="p-2">
      <PageHeader
        title={data?.state?.row?.UnitName}
        buttons={[
          {
            label:excelLoaing?excelStatus?excelStatus.charAt(0) + excelStatus.slice(1) + "..": "": "Excel",
            onClick: () => downoadExcel(),
            color:excelLoaing? COLORS.disable : COLORS.primary,
            disable:excelLoaing?true:false
          },
        ]}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          marginTop: "2%",
        }}
      >
        <div
          style={{ width: "100%", display: "flex", justifyContent: "center" }}
        >
          <BasicDataTable
            customStyle={{
              headCells: {
                style: {
                  fonstSize: 14,
                  fontWeight: "bold",
                  zIndex: 2,
                  "&:first-of-type": {
                    position: "sticky",
                    left: 0,
                    zIndex: 3,
                    background: "#fff",
                  },
                },
              },
              head: {
                style: {
                  backgroundColor: "red",
                  zIndex: 4,
                },
              },
            }}
            dynamicHeightOnRowsPerPage={true}
            paginationTotalRows={employeeListByUnit?.totalRecord || 0}
            onChangePage={(pageNo: number) => {
              handlePagination(pageNo);
            }}
            onChangeRowsPerPage={(newPerPage: any, page: any) => {
              handleonChangeRowsPerPage(newPerPage, page);
            }}
            search={false}
            Title="Employee"
            columns={employeeColumns(handleEmpView)}
            data={
              (!isLoading && isSuccess && employeeListByUnit?.formatedData) ||
              []
            }
            showSpinner={isLoading}
            headerContent={
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginBottom: "15px",
                }}
              >
                {/* Status Dropd  own */}
                <RoundedDropdown
                  options={designationsData?.data || []}
                  refresh={refresh}
                  defaultLabel={
                    dropDown.designation.id === ""
                      ? "All"
                      : dropDown.designation.label
                  }
                  onSelect={(val: any) => handleDesignation(val)}
                  width={"fit-content"}
                  isShowHeading
                  DropdownHeading="Designation"
                  headingColor={COLORS.primary}
                />

                <RoundedDropdown
                  refresh={refresh}
                  options={Expense_Empolyee_StatusFilter}
                  onSelect={(value: any) => handleEmpolyee_status(value)}
                  defaultLabel={
                    dropDown.employeeStatus.id === null
                      ? "All"
                      : dropDown.employeeStatus.label
                  }
                  width={"fit-content"}
                  isShowHeading
                  DropdownHeading="Employee status"
                  headingColor={COLORS.primary}
                />

                <RoundedDropdown
                  refresh={refresh}
                  defaultLabel={dropDown.expenseStatus.label}
                  options={formated_ExpenseStatusWith_All || []}
                  onSelect={(value: any) => handleExpense_status(value)}
                  width={"fit-content"}
                  isShowHeading
                  DropdownHeading="Expense status"
                  headingColor={COLORS.primary}
                />
              </div>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default EmployeeList;

const Expense_Empolyee_StatusFilter = [
  { id: null, label: "All" },
  { id: 1, label: "Active" },
  { id: 0, label: "Inactive" },
];
